module.exports = __webpack_public_path__ + "static/media/screenshot.dca03faa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/devices/MakeyourdayShowcaseBrowser/screenshot.jpg
// module id = 213
// module chunks = 0